import { Pipe, PipeTransform } from '@angular/core';
import { Dictionary } from '@ngrx/entity';

@Pipe({
    name: 'sortByIds',
    standalone: true
})
export class SortByIdsPipe implements PipeTransform {
    transform<T extends any, K extends keyof T>(objectList: T[], ids: T[K][], idProp: K): T[] {
      return ids.map(id => objectList.find(o => o[idProp] === id)).filter(o => o)
    }
}

@Pipe({
    name: 'idsToItems',
    standalone: true
})
export class IdsToItemsPipe implements PipeTransform {
    transform<T>(ids: string[], objects: Dictionary<T> | { [id: string]: T; }): T[] {
      if (!ids || !objects) return []
      return (ids || []).map(id => objects[id]).filter(item => item)
    }
}


